/**
 ****** @Deprecated ******
 ****** Please create new queries/mutations using .graphql files******
 */

import { gql } from '@apollo/client';

export const GENERATE_MULTIPASS_TOKEN = gql`
  mutation GenerateMultipassToken($returnTo: String!) {
    generateMultipassToken(returnTo: $returnTo) {
      token
    }
  }
`;

export const GENERATE_AVANT_PASS_TOKEN = gql`
  mutation GenerateAvantPassToken($input: GenerateAvantPassTokenInput!) {
    generateAvantPassToken(input: $input) {
      token
    }
  }
`;

export const CREATE_ADDRESS = gql`
  mutation CreateAddress($address: CreateOrUpdateAddressInput!) {
    createAddress(address: $address) {
      id
      addressLine1
      addressLine2
      city
      countryCode
      countryName
      customsCode
      company
      firstName
      lastName
      phone
      provinceCode
      provinceName
      zip
      isDefault
    }
  }
`;

export const UPDATE_ADDRESS = gql`
  mutation UpdateAddress(
    $addressId: String!
    $changes: CreateOrUpdateAddressInput!
  ) {
    updateAddress(addressId: $addressId, changes: $changes) {
      id
      addressLine1
      addressLine2
      city
      countryCode
      countryName
      customsCode
      company
      firstName
      lastName
      phone
      provinceCode
      provinceName
      zip
      isDefault
    }
  }
`;

export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($addressId: String!) {
    deleteAddress(addressId: $addressId)
  }
`;

export const WEB3_GENERATE_NONCE = gql`
  mutation Web3GenerateNonce($walletAddress: String!, $message: String!) {
    web3GenerateNonce(walletAddress: $walletAddress, message: $message)
  }
`;

export const WEB3_VERIFY_SIGNATURE = gql`
  mutation Web3VerifySignature($walletAddress: String!, $signature: String!) {
    web3VerifySignature(walletAddress: $walletAddress, signature: $signature)
  }
`;

export const MUTATION_ENTER_DRAW = gql`
  mutation MutationEnterDraw($id: ID!, $refID: String, $note: String) {
    enterDraw(id: $id, refID: $refID, note: $note) {
      accountIsInDraw
    }
  }
`;

export const AUTHENTICATE_NFT_PRINT = gql`
  mutation authenticateNftPrint($input: AuthenticateNftPrintInput!) {
    authenticateNftPrint(input: $input) {
      print {
        id
        tokenId
        owner
        authenticated
        productId
        orderedAt
      }
      events {
        id
        owner
        authenticated
        productId
        createTime
        event
      }
    }
  }
`;

export const MUTATION_DETACH_PAYMENT_METHOD = gql`
  mutation MutationDetachPaymentMethod(
    $id: ID!
    $providerId: PaymentProvider!
  ) {
    detachPaymentMethod(id: $id, providerId: $providerId)
  }
`;
/**
 ****** @Deprecated ******
 ****** Please create new queries/mutations using .graphql files******
 */
